module.exports = __webpack_public_path__ + "assets/multiplayer-icon.30ee6d4b.svg";